import { instance } from "api/apiBase";
import {
  GetDiscountsResponse,
  CreateDiscountRequest,
  UpdateDiscountRequest,
  DiscountCode
} from "../types";

const api = {
  // Portal API (for Partners) - /portal/v1/discounts
  getDiscounts: ({
    active,
    restriction_type,
    discount_type,
    per_page = 999,
    page = 1
  }: {
    active?: boolean;
    restriction_type?: "template" | "applicant";
    discount_type?: "percentage" | "flat" | "free";
    per_page?: number;
    page?: number;
  }): Promise<GetDiscountsResponse> => {
    return instance
      .get(`/portal/v1/discounts`, {
        params: {
          active,
          restriction_type,
          discount_type,
          per_page,
          page
        }
      })
      .then(({ data }) => data);
  },

  getDiscount: (discountId: number): Promise<DiscountCode> => {
    return instance
      .get(`/portal/v1/discounts/${discountId}`)
      .then(({ data }) => data);
  },

  createDiscount: (data: CreateDiscountRequest): Promise<DiscountCode> => {
    return instance.post(`/portal/v1/discounts`, data).then(({ data }) => data);
  },

  updateDiscount: (
    discountId: number,
    data: UpdateDiscountRequest
  ): Promise<DiscountCode> => {
    return instance
      .put(`/portal/v1/discounts/${discountId}`, data)
      .then(({ data }) => data);
  },

  deleteDiscount: (discountId: number): Promise<DiscountCode> => {
    return instance
      .delete(`/portal/v1/discounts/${discountId}`)
      .then(({ data }) => data);
  },

  // Application Management
  applyDiscountToApplicant: (
    applicationId: number,
    applicantId: number,
    data: {
      discount_code: string;
      custom_discount_type?: string;
      custom_discount_amount?: number;
      custom_end_date?: string;
    },
    isApplicantEntity: boolean = true
  ) => {
    const body = data.custom_discount_type
      ? {
          discount_code: data.discount_code,
          discount_type: data.custom_discount_type,
          discount_amount: data.custom_discount_amount,
          end_date: data.custom_end_date
        }
      : {
          discount_code: data.discount_code
        };

    return instance
      .post(
        isApplicantEntity
          ? `/portal/v1/applications/${applicationId}/applicants/${applicantId}/apply_discount`
          : `/portal/v1/magic_links/${applicantId}/apply_discount`,
        body
      )
      .then(({ data }) => data);
  },

  generateDiscountCode: () => {
    return instance
      .post<{ code: string }>(`/portal/v1/discounts/generate_code`)
      .then(({ data }) => data);
  },

  removeDiscountFromApplicant: (
    applicationId: number,
    applicantId: number,
    isApplicantEntity: boolean = true
  ) => {
    return instance
      .post(
        isApplicantEntity
          ? `/portal/v1/applications/${applicationId}/applicants/${applicantId}/remove_discount`
          : `/portal/v1/magic_links/${applicantId}/remove_discount`
      )
      .then(({ data }) => data);
  }
};

export default api;
